import {Tr} from "@/i18n/i18n";
import Scene = Phaser.Scene;
import {Keys} from "@/constants/key";
import TextUtils from "@/utils/text-utils";
import {SquareButton} from "@/scenes.ui/square-button";
import {Fonts} from "@/constants/font";
import {VerticalStandardPanel} from "@/scenes.ui/vertical-standard-panel";
import {Player} from "@/store/player/types";
import SpriteUtils from "@/utils/sprite-utils";
import PlayerStore from "@/store/player";
import {TabName} from "@/services/shop-service";
import {CampaignWheelPanel} from "@/scenes.ui/campaign-wheel-panel";
import SoundUtils from "@/utils/sound-utils";

export class EverydayRewardPanel extends VerticalStandardPanel {

    constructor(scene: Scene, canvas: HTMLCanvasElement, player: Player, withShareCheck: boolean, takeCallback: (shareCheck: boolean) => unknown) {
        super(scene, canvas, Tr('s.vozvrascheniem'));
        this.xButton.setVisible(false);
        const self = this;

        let shift = withShareCheck ? 5 : 0;
        let infoText = TextUtils.addTextByFamily(scene, Tr('radi.vas.videt'),
            0, -180 - shift, '#ffd465', 18, 'normal', 450, Fonts.MYRIADPRO_BOLD);

        let improveLabel = TextUtils.addTextAdvanced(scene, Tr('darim.vam.ezhednevniy.podarok'), 0, -125 - shift * 2,
            '#ffffff', 13, 'normal', 400, 'center', 2, Fonts.ARIAL_MT);

        let awardIcon = SpriteUtils.addSprite(this.scene, 0, -60 - shift * 3, Keys.IC_100_MITHRIL);

        let awardComment = TextUtils.addTextByFamily(this.scene, String(player.todayAward) +
            TextUtils.chooseWord(player.todayAward, Tr('izumrud'), Tr('izumruda'), Tr('izumrudov')),
            0, -10 - shift * 4, '#ffffff', 14, 'normal', 450, Fonts.MYRIADPRO_BOLD);

        let tomorrowComment = TextUtils.addTextAdvanced(scene, Tr('zahodite.v.igru.zavtra.i.poluchite') + String(player.tomorrowAward) +
            TextUtils.chooseWord(player.tomorrowAward, Tr('izumrud'), Tr('izumruda'), Tr('izumrudov')), 0, 45 - shift * 5,
            '#babab7', 12, 'normal', 390, 'center', 2, Fonts.ARIAL_MT);

        let checked = false;
        if (withShareCheck) {
            let shareText = TextUtils.addTextByFamily(scene, Tr('share'),
                20, 70, '#d0cac4', 13, 'normal', 450, Fonts.MYRIADPRO_BOLD);

            let box = SpriteUtils.addImage(this.scene, -124, 69, Keys.ATLAS_PROFILE, Keys.UI_SQ_BUTTON);
            SpriteUtils.setDispSize(box, 25, 25);
            let check = SpriteUtils.addImage(this.scene, -123, 68, Keys.ATLAS_PROFILE, Keys.UI_CHECK_SIGN).setVisible(false);

            box.setInteractive().on('pointerup', () => {
                checked = !checked;
                check.setVisible(checked);
            });

            shareText.setInteractive().on('pointerup', () => {
                checked = !checked;
                check.setVisible(checked);
            });

            this.add([shareText, box, check]);
        }

        this.add([infoText, awardIcon, awardComment, improveLabel, tomorrowComment]);

        this.addCustomButton(0, 150 + shift * 2, Tr('prinjat'), Keys.UI_ART_GREEN_BUTTON, Keys.ATLAS_PROFILE, Keys.UI_GOLDEN_CHECK, () => {
            takeCallback(checked);
        });
    }

}
